// ─── Quién dejó el trabajo a medias ──────────────────────────────────────────
// Cada documento guarda quién lo creó. Sirve para que el recordatorio de
// pendientes sea de cada quien: a nadie se le muestran los borradores de otro,
// porque un borrador ajeno no es un hilo perdido propio — es ruido, y peor aún,
// deja ver trabajo que no le corresponde.
//
// Identifica el CORREO, no el nombre: los nombres se repiten y se cambian. El
// nombre se guarda aparte, denormalizado, solo para mostrarlo — así el aviso
// sigue diciendo de quién era aunque esa persona ya no esté en la empresa.
import { state } from "./state.js";

// Sella el autor si el documento aún no lo tiene. NO se reescribe al editar:
// si otra persona corrige un borrador ajeno, el trabajo sigue siendo de quien
// lo empezó, y es a esa persona a quien hay que recordárselo.
export function sellarAutor(doc) {
  if (!doc || doc._creadoPor || !state.usuarioEmail) return doc;
  doc._creadoPor = state.usuarioEmail;
  doc._creadoPorNombre = state.usuarioNombre || state.usuarioEmail;
  return doc;
}

// ¿Este documento es del usuario que tiene la sesión abierta?
// Los documentos SIN autor (creados antes de que se registrara) se consideran
// de todos: es preferible que alguien vea un pendiente que no era suyo a que un
// trabajo a medias desaparezca sin que nadie lo retome.
export function esMio(doc) {
  if (!doc) return false;
  if (!doc._creadoPor) return true;
  return doc._creadoPor === state.usuarioEmail;
}

// Nombre a mostrar del autor, o cadena vacía si no se registró.
export function nombreAutor(doc) {
  if (!doc || !doc._creadoPor) return "";
  return doc._creadoPorNombre || doc._creadoPor;
}
